import { useEffect, useRef, useState } from 'react';

type UseHookParams = {
    setMenuIsOpen: (open: boolean) => void
}

const useHook = ({ setMenuIsOpen }: UseHookParams) => {

  const [open, setOpen] = useState(false);
  const [festividadesOpen, setFestividadesOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const triggerRef = useRef<HTMLElement | null>(null);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => setMenuIsOpen(false), 300);
  };

  useEffect(() => {
    triggerRef.current = document.activeElement as HTMLElement;
    const openId = setTimeout(() => setOpen(true), 20);
    const focusId = setTimeout(() => closeButtonRef.current?.focus(), 50);
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handleClose();
        return;
      }
      if (e.key === 'Tab' && menuRef.current) {
        const focusable = menuRef.current.querySelectorAll<HTMLElement>('a[href], button:not([disabled])');
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      clearTimeout(openId);
      clearTimeout(focusId);
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKeyDown);
      triggerRef.current?.focus();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    open,
    festividadesOpen,
    setFestividadesOpen,
    menuRef,
    closeButtonRef,
    handleClose,
  };
};

export default useHook;
